import { useSettings } from '@queries/settings'
import { useParams } from '@stores/params'

export const useIsWorkingWithPassengerTypes = (): boolean => {
  const [settings] = useSettings()
  const [params] = useParams()
  const { passengerTypesList } = settings

  return passengerTypesList.enabled || !!params.bookingId
}
